import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EfImg from '@elem/ui/ef-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const LinkIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="11" viewBox="0 0 406 11" fill="none">
        <path d="M1 0.242188V10.1277H404.51V0.242188" stroke="#696C71" />
    </svg>
);

const LinkIcon2 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="11" viewBox="0 0 481 11" fill="none">
        <path d="M1 0.149414V10.035H480V0.149414" stroke="#696C71" />
    </svg>
);

export default function SectionGraphCompare() {
    const { t } = useLang('SectionGraphCompare');

    return (
        <div className={styles.SectionGraphCompare}>
            <EcoSpace hPc="160px" hPad="100px" hH5="100px" />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className="eco-content">
                <div className="sgc-content">
                    <div className="sgc-graph">
                        <EfImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1748162032889/typec.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1748162035862/typec_h5.jpg"
                        />
                        <div className="btn-left">{t('p_type')}</div>
                        <div className="btn-right">{t('n_type')}</div>
                    </div>
                    <div className="sgc-info">
                        <div className="sgc-title">{t('compare_title')}</div>
                        <div className="line1">
                            <div className="sgc-progress">
                                <div className="sgc-progress-text">{t('p_type')}</div>
                            </div>
                            <div className="line-icon">
                                <LinkIcon />
                            </div>
                            <div className="time-line">
                                <span>07:00</span>
                                <span>18:00</span>
                            </div>
                        </div>
                        <div className="line2">
                            <div className="sgc-progress">
                                <div className="sgc-progress-text">{t('n_type')}</div>
                            </div>
                            <div className="line-icon">
                                <LinkIcon2 />
                            </div>
                            <div className="time-line">
                                <span>06:00</span>
                                <span>19:00</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
